import { render, staticRenderFns } from "./SmsNotificationSettings.vue?vue&type=template&id=2e408cb6&"
import script from "./SmsNotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./SmsNotificationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports